export default __webpack_public_path__ + "static/media/airstrapz-wht-banner-3.52582a68.jpg";